const state = {
    id: 0,
    quote: "",
    level_name: "",
    level_id: 0,
};

const mutations = {
    quote_init(state, payload) {
        state.id = payload.id;
        state.quote = payload.quote;
        state.level_name = payload.level_name;
        state.level_id = payload.level_id;
    },
};

export default { state, mutations };



// WEBPACK FOOTER //
// ./src/modules/ambis_meter/stores/quote.js